import { Eyebrow, Reveal } from "./motion";

const VALUES = [
    {
        num: "01",
        title: "Clinical precision",
        desc: "Cosmeceutical treatments backed by skin science — every formulation chosen for your barrier, your concerns, your results.",
    },
    {
        num: "02",
        title: "Inside-out care",
        desc: "Gut health, dietary advice and wellness rituals woven into every skin plan, because skin is a whole-body story.",
    },
    {
        num: "03",
        title: "Unhurried rituals",
        desc: "Time, quiet and attention. No rushed appointments, no one-size-fits-all — just considered care, start to finish.",
    },
];

export default function WhoWeAre() {
    return (
        <section
            id="who-we-are"
            data-testid="who-we-are-section"
            className="bg-linen px-6 py-24 md:px-12 md:py-36"
        >
            <div className="mx-auto grid max-w-[1440px] grid-cols-1 gap-14 md:grid-cols-12">
                <div className="md:col-span-5">
                    <div className="md:sticky md:top-28">
                        <Eyebrow index="02">Who we are</Eyebrow>
                        <Reveal delay={0.1}>
                            <h2 className="mt-8 font-serif text-[clamp(2.2rem,4.5vw,4.25rem)] font-light leading-[1.05] text-ink">
                                Skin health is
                                <br />
                                <span className="italic text-earth">whole-body health.</span>
                            </h2>
                        </Reveal>
                    </div>
                </div>

                <div className="md:col-span-7">
                    <Reveal delay={0.15}>
                        <p className="max-w-xl text-base font-light leading-relaxed text-earth md:text-lg">
                            In Skin is a clinical skin studio built on a simple
                            belief: lasting results come from treating skin as a
                            whole-body story. Every appointment begins with
                            listening — to your skin, your gut and your daily
                            rituals — before a single product touches your face.
                        </p>
                    </Reveal>

                    <Reveal delay={0.25}>
                        <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-earth md:text-lg">
                            From a signature facial to an advanced treatment plan,
                            everything is tailored, unhurried and entirely yours.
                        </p>
                    </Reveal>

                    <div className="mt-12 border-t border-ink/10">
                        {VALUES.map((v, i) => (
                            <Reveal key={v.num} delay={0.1 + i * 0.1}>
                                <div
                                    data-testid={`who-we-are-value-${v.num}`}
                                    className="flex gap-8 border-b border-ink/10 py-8"
                                >
                                    <span className="font-serif text-3xl font-light italic text-clay/50">
                                        {v.num}
                                    </span>
                                    <div>
                                        <h3 className="font-serif text-2xl font-light text-ink">
                                            {v.title}
                                        </h3>
                                        <p className="mt-3 max-w-md text-sm font-light leading-relaxed text-earth md:text-base">
                                            {v.desc}
                                        </p>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
